/* TODO: t() */
import React from 'react';
import { View, StyleSheet, TextStyle } from 'react-native';

import Icon, { IconName, IconSize } from './Icon';
import Text from './Text';
import { themeColors } from './Constants';

type Props = {
  iconName: IconName;
  iconSize?: IconSize;
  color?: string;
  text: string;
  style?: StyleSet;
  iconStyle?: StyleSet;
  textStyle?: TextStyle;
};

export default function IconWithText(props: Props) {
  let {
    iconName,
    iconSize = 'S',
    text,
    iconStyle,
    textStyle,
    style,
    color = themeColors.black,
  } = props;
  let textColor = color ? { color } : null;
  return (
    <View style={[styles.container, style]}>
      <Icon
        name={iconName}
        size={iconSize}
        color={color}
        style={[styles.iconStyle, iconStyle]}
      />
      <Text style={[styles.textColor, textColor, textStyle]}>{text}</Text>
    </View>
  );
}

let styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  iconStyle: {
    marginRight: 10,
  },
  textColor: {
    color: themeColors.black,
  },
});
